import React from 'react';
import {Link} from 'react-router';

import styles from './ProductPage.m.sass';
import content from '../../components/content/Content.m.sass';

import {connect} from 'react-redux';
import {fetchProductBySlug} from '../../ducks/products';
import {fetchEventProductsByProductPreset} from '../../ducks/eventProducts';
import {addProductToCart} from '../../ducks/cart';
import {openModal} from '../../ducks/ui';

import {findProductMenuTaxon} from '../../utils/taxons';

import withChannelFormatters from '../channelUtils/withChannelFormatters';

import LocationDispatchingSink from '../locationDispatchingSink/LocationDispatchingSink';
import Content from '../../components/content/Content';
import BreadcrumbsContainer from '../breadcrumbsContainer/BreadcrumbsContainer';
import MenuContainer from '../menuContainer/MenuContainer';
import OnlineSupport from '../../components/onlineSupport/OnlineSupport';
import Reviews from '../../components/reviews/Reviews';
import RawHtml from '../../components/rawHtml/RawHtml';

import ProductPurchase from '../../components/productPurchase/ProductPurchase';
import TrustPilot from '../../components/trustPilot/TrustPilot';
import GoBack from '../../components/goBack/GoBack';
import withMediaQueries from '../withMediaQueries/withMediaQueries';
import Scroller from '../../components/scroller/Scroller';
import ProductList from '../../components/product/ProductList';
import CartModalContainer from '../cartModalContainer/CartModalContainer';
import Loader from '../../components/loader/Loader';
import Wysiwyg from "../../components/wysiwyg/Wysiwyg";
import ErrorPage from '../errorPage/ErrorPage';
import Meta from '../../components/meta/Meta';
import JSONLDProduct from '../../components/JSON-LD/JSONLDProduct';


@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
@withChannelFormatters
@connect(({taxons, products, eventProducts}, {params, location}) => ({
  product: products[params.splat],
  productEvents: (products[params.splat] && eventProducts.product[products[params.splat].id]) && (location.query.eventPreset
    ? eventProducts.product[products[params.splat].id][location.query.eventPreset]
    : products[params.splat].eventOptionPreset && eventProducts.product[products[params.splat].id][products[params.splat].eventOptionPreset.id]),
}))
export default class ProductPage extends React.PureComponent {
  static fetchData = ({dispatch, params, location}) => dispatch(fetchProductBySlug(params.splat))
    .then(product => ProductPage.fetchRelatedData({dispatch, location, product}));

  static fetchProductEvents = ({dispatch, location, product, productEvents}) => (productEvents === undefined) && (
    location.query.eventPreset
      ? dispatch(fetchEventProductsByProductPreset(product.id, location.query.eventPreset))
      : product.eventOptionPreset && dispatch(fetchEventProductsByProductPreset(product.id, product.eventOptionPreset.id))
  );

  static fetchRelatedData = ({dispatch, location, product, productEvents}) => Promise.all([
    MenuContainer.fetchData({dispatch, menuTaxon: findProductMenuTaxon(product).slug}),
    ProductPage.fetchProductEvents({dispatch, location, product, productEvents})
  ]);

  static associationCode = 'See-also';

  componentDidMount() {
    const {dispatch, params, product} = this.props;

    if (product === undefined) {
      dispatch(fetchProductBySlug(params.splat));
    }

    if (product) {
      ProductPage.fetchProductEvents(this.props);
    }
  }

  componentDidUpdate(prevProps) {
    const {dispatch, params, product} = this.props;

    if (product === undefined) {
      dispatch(fetchProductBySlug(params.splat));
    }

    if (product && product !== prevProps.product) {
      ProductPage.fetchProductEvents(this.props);
    }
  }

  onProductPurchase = product => {
    const {dispatch} = this.props;

    return dispatch(addProductToCart(product)).then(() => dispatch(openModal(CartModalContainer)));
  };

  render() {
    const {collapsed, product, productEvents, location, channelFormatters} = this.props;

    if (product === false) {
      return <ErrorPage/>;
    }

    const eventsEnabled = !!location.query.eventPreset || !!(product && product.eventOptionPreset);

    const relatedProducts = product && product.associations.find(it => it.type.code === ProductPage.associationCode);

    const productOccurrences = productEvents && productEvents
      .reduce(
        (acc, {id, preset, occurrences, timezone, productVariant, optionValues}) =>
          occurrences.map(occurrence => ({id, preset, occurrence, timezone, productVariant, optionValues})).concat(acc),
        []
      ).sort(
        (a, b) => (Date.parse(a.occurrence) - Date.parse(b.occurrence)) || a.productVariant.id - b.productVariant.id
      );

    let initialOccurrence;
    if (productOccurrences) {
      initialOccurrence = productOccurrences.find(occurrence => occurrence.id == location.query.eventId && occurrence.occurrence === location.query.occurrence);

      if (!initialOccurrence) {
        initialOccurrence = productOccurrences[0];
      }
    }

    const productMeta = (product && product.metatag) || {};

    return (
      <div>
        {!!product && (
          <LocationDispatchingSink
            menuTaxon={findProductMenuTaxon(product).slug}
            breadcrumbs={product.mainTaxonParents.filter(it => it.level > 0).concat(product.mainTaxon)}
          />
        )}

        {!!product && (
          <Meta
            title={productMeta.pageTitle}
            fallbackTitle={product.name}
            description={productMeta.description}
            keywords={productMeta.keywords}
            image={!!product.images.length && product.images[0].path}
          />
        )}

        {!!product && (
          <JSONLDProduct
            name={product.name}
            image={!!product.images.length && product.images[0].path}
            price={channelFormatters.price(product.variants[0].price).replace(' ', '')}
            currency={channelFormatters.currencyCode()}
            inStock={!!product.inStock}
          />
        )}

        {collapsed && (
          <GoBack/>
        )}

        <Content>
          {!collapsed && (
            <div className={content.content_top}>
              <div className="container">
                <BreadcrumbsContainer append={product ? [{name: product.name}]: []}/>
              </div>
            </div>
          )}

          <div className="container">
            <div className={content.content_inner}>
              <div className={content.content_row}>
                {!collapsed && (
                  <div className={content.content_sidebar}>
                    <MenuContainer/>
                    <TrustPilot apart/>
                    <OnlineSupport/>
                  </div>
                )}

                {!product || eventsEnabled && !productEvents ? (
                  <Loader page/>
                ) : (
                  <React.Fragment>
                    <div className={content.content_full}>
                      <h1 className={content.content_header}>{productMeta.headTitle || product.name}</h1>
                      {!collapsed && (
                        <Wysiwyg>
                          <RawHtml content={product.description}/>
                        </Wysiwyg>
                      )}
                    </div>

                    <ProductPurchase
                      product={product}
                      occurrences={productOccurrences}
                      initialVariant={location.query.variant}
                      initialOccurrence={initialOccurrence}
                      onPurchase={this.onProductPurchase}
                    />

                    {collapsed && (
                      <div className={styles.productPage_mobileDesc}>
                        <Wysiwyg>
                          <RawHtml content={product.description} />
                        </Wysiwyg>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>

              {!!(relatedProducts && relatedProducts.associatedProducts) && (
                <div className={styles.productPage_related}>
                  <h3 className={styles.productPage_relatedHeader}><span>Related</span> Products</h3>

                  {/*TODO: refactor this*/}
                  {!collapsed && (
                    <div className={content.content_row}>
                      <ProductList
                        related
                        products={relatedProducts.associatedProducts}
                      />
                    </div>
                  )}

                  {collapsed && (
                    <Scroller>
                      <ProductList
                        horizontal
                        products={relatedProducts.associatedProducts}
                      />
                    </Scroller>
                  )}
                </div>
              )}
            </div>
          </div>
        </Content>

        <Reviews title="Our reviews"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/productPage/ProductPage.js